import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
//@ts-ignore
import { AccessControl, PermissionRequired } from "@careinfo/permission-required";
import CreateVehicleType from "../pages/VehicleType/CreateVehicle";
import EditVehicleType from "../pages/VehicleType/EditVehicle";
import VehicleTypeList from "../pages/VehicleType/VehicleList";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
        <Route path={"/"} element={
          <AccessControl children={<VehicleTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-type"} element={
          <AccessControl children={<VehicleTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create"}  element={
          <AccessControl children={<CreateVehicleType />}
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        
        <Route path={"/edit/:id"} element={
          <AccessControl children={<EditVehicleType />}
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
       
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;